import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { StyledBadgeNotification, Badge } from './styles.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const BadgeNotification = (_a) => {
    var { children, countNotifications, variation = 'alert' } = _a, props = __rest(_a, ["children", "countNotifications", "variation"]);
    const countPlus = countNotifications && countNotifications > 99 ? '99+' : countNotifications;
    return (React.createElement(StyledBadgeNotification, Object.assign({}, props),
        React.createElement(Badge, { variation: variation, isDot: !countNotifications }, countPlus),
        React.createElement(Caption, null, children)));
};

export { BadgeNotification as default };
